// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loading {
  position: absolute;
  top: 0;
  background-color: var(--bg-color);
  width: 100%;
  height: 100vh;
  z-index: 99;
}

.loading-content {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30vh;
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.loading-content .waitMessage {
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 10px;
}

.loading-content .loadingImage {
  width: 60px;
  margin-top: 10px;
}

.loading-content .loadingImage img {
  width: 100%;
  background-color: white;
}

.animation-btn {
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
  font-family: Red Hat Display;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding: 8px 11px;
  text-align: left;
  transition: all linear 0.2s;
}

.animation-btn svg {
  position: absolute;
  right: 20px;
  top: 22%;
  transition: all linear 0.2s;
}

.animation-btn:hover,
.animation-btn:focus,
.animation-btn:active {
  animation: pulse 1s;
  box-shadow: 0 0 0 2em rgba(255, 255, 255, 0);
}

.payment-btn {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  background: linear-gradient(160.35deg, #FFA329 13.16%, #FE7B1C 42.24%, #FC2A01 71.32%);
  box-sizing: border-box;
  border: 1px solid #777778;
  border-radius: 10px;
  margin-right: 60px;
}
.payment-btn.clicked {
  background-color: black;
}

.payment-method .custom-button {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  background: linear-gradient(160.35deg, #FFA329 13.16%, #FE7B1C 42.24%, #FC2A01 71.32%);
  box-sizing: border-box;
  border: 1px solid #777778;
  border-radius: 10px;
  margin-right: 60px;
}
.payment-method .button-text {
  color: var(--font-color);
  margin-left: 25px;
}
.payment-method.active {
  background: black;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 #FFA329;
  }
}
.animation-btn:hover svg {
  right: 9px;
}

/* sign in */
.solution {
  margin-top: 44px;
  text-align: center;
}

.solution-heading {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 3px;
}

.solution-content {
  color: #777778;
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px; /* 162.5% */
  letter-spacing: -0.5px;
  margin-bottom: 17px;
}

.main-text {
  color: #777778;
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px; /* 162.5% */
  letter-spacing: -0.5px;
}

.main-text span {
  color: #FFA329 !important;
  cursor: pointer;
}

.placeholder {
  margin-left: 40px;
}

@media screen and (max-width: 1000px) {
  .main-text {
    font-size: 14px;
  }
  .solution button {
    margin-bottom: 174px;
  }
  .animation-btn {
    padding: 8px 47px 8px 12px;
    right: 8px;
    bottom: 2.5px;
  }
  .animation-btn img {
    right: 14px;
  }
  .placeholder {
    font-size: 15px;
  }
}
.analytics-container .proxy-list {
  display: block;
}
@media (max-width: 718px) {
  .analytics-container .proxy-list {
    display: none;
  }
}

.order-container .proxy-list {
  display: block;
}

.generate-container .proxy-list {
  display: none;
}
@media (max-width: 718px) {
  .generate-container .proxy-list {
    display: block;
    border: none;
    padding: 0;
  }
}

@media (min-width: 781px) {
  .purchase-container,
  .analytics-container,
  .generate-container {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/dashboard.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,MAAA;EACA,iCAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,uBAAA;AACJ;;AAEA;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;AACF;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AACJ;;AAEA;;;EAGE,mBAAA;EACA,4CAAA;AACF;;AAEA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sFAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AACI;EACI,uBAAA;AACR;;AAKI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sFAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAFR;AAKI;EACI,wBAAA;EACA,iBAAA;AAHR;AAMI;EACI,iBAAA;AAJR;;AASA;EACE;IAAK,2BAAA;EALL;AACF;AAOA;EACI,UAAA;AALJ;;AAQA,YAAA;AACA;EACI,gBAAA;EACA,kBAAA;AALJ;;AAQA;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AALJ;;AAQA;EACI,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,sBAAA;EACA,mBAAA;AALJ;;AAQA;EACI,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,sBAAA;AALJ;;AAQA;EACI,yBAAA;EACA,eAAA;AALJ;;AAQA;EACI,iBAAA;AALJ;;AAQA;EACE;IACE,eAAA;EALF;EAQA;IACI,oBAAA;EANJ;EASA;IACI,0BAAA;IACA,UAAA;IACA,aAAA;EAPJ;EAUA;IACI,WAAA;EARJ;EAWA;IACI,eAAA;EATJ;AACF;AAaE;EACE,cAAA;AAXJ;AAaI;EAHF;IAII,aAAA;EAVJ;AACF;;AAeE;EACE,cAAA;AAZJ;;AAiBE;EACE,aAAA;AAdJ;AAgBI;EAHF;IAII,cAAA;IACA,YAAA;IACA,UAAA;EAbJ;AACF;;AAiBA;EACE;;;IAGE,cAAA;EAdF;AACF","sourcesContent":["#loading {\n    position: absolute;\n    top: 0;\n    background-color: var(--bg-color);\n    width: 100%;\n    height: 100vh;\n    z-index: 99;\n\n}\n.loading-content {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 30vh;\n    color: var(--font-color);\n    font-family: Red Hat Display;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n\n.loading-content .waitMessage {\n    color: var(--font-dark-color);\n    font-family: Red Hat Display;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin-top: 10px;\n}\n\n.loading-content .loadingImage {\n    width: 60px;\n    margin-top: 10px;\n}\n\n.loading-content .loadingImage img {\n    width: 100%;\n    background-color: white;\n}\n\n.animation-btn {\n  border: none;\n  cursor: pointer;\n  flex-shrink: 0;\n  position: relative;\n  font-family: Red Hat Display;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 22px;\n  padding: 8px 11px;\n  text-align: left;\n  transition: all linear 0.2s;\n}\n\n.animation-btn svg {\n    position: absolute;\n    right: 20px;\n    top: 22%;\n    transition: all linear 0.2s;\n}\n\n.animation-btn:hover,\n.animation-btn:focus,\n.animation-btn:active {\n  animation: pulse 1s;\n  box-shadow: 0 0 0 2em rgba(#fff,0);\n}\n\n.payment-btn {\n    width: 20px;\n    height: 20px;\n    margin-top: 10px;\n    background: linear-gradient(160.35deg, #FFA329 13.16%, #FE7B1C 42.24%, #FC2A01 71.32%);\n    box-sizing: border-box;\n    border: 1px solid #777778;\n    border-radius: 10px;\n    margin-right: 60px;\n\n    &.clicked {\n        background-color: black;\n    }\n\n}\n\n.payment-method {\n    .custom-button {\n        width: 20px;\n        height: 20px;\n        margin-top: 10px;\n        background: linear-gradient(160.35deg, #FFA329 13.16%, #FE7B1C 42.24%, #FC2A01 71.32%);\n        box-sizing: border-box;\n        border: 1px solid #777778;\n        border-radius: 10px;\n        margin-right: 60px;\n    }\n\n    .button-text {\n        color: var(--font-color);\n        margin-left: 25px;\n    }\n\n    &.active {\n        background: black;\n    }\n\n}\n\n@keyframes pulse {\n  0% { box-shadow: 0 0 0 0 #FFA329; }\n}\n\n.animation-btn:hover svg {\n    right: 9px;\n}\n\n/* sign in */\n.solution {\n    margin-top: 44px;\n    text-align: center;\n}\n\n.solution-heading {\n    color: var(--font-color);\n    font-family: Red Hat Display;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin-bottom: 3px;\n}\n\n.solution-content {\n    color: #777778;\n    font-family: Red Hat Display;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 26px; /* 162.5% */\n    letter-spacing: -0.5px;\n    margin-bottom: 17px; \n}\n\n.main-text {\n    color: #777778;\n    font-family: Red Hat Display;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 26px; /* 162.5% */\n    letter-spacing: -0.5px;\n}\n\n.main-text span {\n    color: #FFA329!important;\n    cursor: pointer;\n}\n\n.placeholder {\n    margin-left: 40px;\n}\n\n@media screen and (max-width: 1000px) {\n  .main-text {\n    font-size: 14px;\n  }\n\n  .solution button {\n      margin-bottom: 174px;\n  }\n\n  .animation-btn {\n      padding: 8px 47px 8px 12px;\n      right: 8px;\n      bottom: 2.5px;\n  }\n\n  .animation-btn img {\n      right: 14px;\n  }\n\n  .placeholder {\n      font-size: 15px;\n  }\n}\n\n.analytics-container {\n  .proxy-list {\n    display: block;\n\n    @media (max-width: 718px) {\n      display: none;\n    }\n  }\n}\n\n.order-container {\n  .proxy-list {\n    display: block;\n  }\n}\n\n.generate-container {\n  .proxy-list {\n    display: none;\n\n    @media (max-width: 718px) {\n      display: block;\n      border: none;\n      padding: 0;\n    }\n  }\n}\n\n@media (min-width: 781px) {\n  .purchase-container,\n  .analytics-container,\n  .generate-container {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
